import React from 'react';

// Styles & Assets
import styles from './UserActions.module.css';

// Services
import { isResidenceFeatureEnabled } from '../../../services/residences';

// Components
import EditButtonUser from '../EditButtonUser/EditButtonUser';
import UserQR from '../UserQR/UserQR';

// Models
import { UserData } from '../../../interfaces/UserInfo';
interface Props {
    user: UserData
    updateUser: (user: UserData) => void
}

const UserActions: React.FC<Props> = ({ user, updateUser }) => {

    return (
        <div className={styles.actionsContainer}>
            <EditButtonUser
                user={user}
                updateUser={updateUser}
            />
            {isResidenceFeatureEnabled() &&
                <UserQR user={user} />
            }
        </div>
    );
};

export default UserActions;